export const Prodcat = {
    features: 'features'
};
